import React from 'react';

import { ModalStrategyComponent } from './modal-strategy-component';
import { IntegrationDefinition, ModalIntegrationProps } from './modal-strategy.types';
import { createFeatureToggleStrategyIntegration } from '../../feature-toggle-strategy-integration';

export const createModalIntegration = (props: ModalIntegrationProps): IntegrationDefinition => ({
    id: props.id,
    Component: componentProps => (
        <ModalStrategyComponent {...props} {...componentProps} />
    ),
});

export const createFeatureToggleModalIntegration = (
    props: ModalIntegrationProps,
) => createFeatureToggleStrategyIntegration(props, createModalIntegration);
